import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
	return axios.get(`/get/funding-body/student-course-session/${courseSessionId}`, { params })
}
